// Muxum reveal-on-scroll — fades elements in when they enter viewport.
// Usage: add class "mx-reveal" to any element. Optional data-mx-reveal-delay="120" (ms).
(() => {
  if (window.__mxRevealInit) return;
  window.__mxRevealInit = true;
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.mx-reveal').forEach((el) => el.classList.add('is-in'));
    return;
  }
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) {
        const delay = parseInt(e.target.dataset.mxRevealDelay || '0', 10);
        setTimeout(() => e.target.classList.add('is-in'), delay);
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  const observe = () => document.querySelectorAll('.mx-reveal:not(.is-in)').forEach((el) => io.observe(el));
  observe();

  // Re-observe after section refresh.
  document.addEventListener('shopify:section:load', observe);
})();
